import * as React from "react";
const SvgFiRrPaintbrushPencil = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-paintbrush-pencil_svg__a)">
      <path d="M22.926 6.264a3.673 3.673 0 0 0 0-5.188 3.67 3.67 0 0 0-5.189 0L6.8 12.011a5.5 5.5 0 0 0-4.196 1.601c-1.5 1.502-2.349 5.741-2.587 7.771a2.31 2.31 0 0 0 .664 1.918 2.3 2.3 0 0 0 1.918.664c.241-.028 5.938-.718 7.79-2.569a5.49 5.49 0 0 0 1.6-4.195zM8.973 19.98c-.854.854-4.095 1.701-6.609 1.997a.31.31 0 0 1-.27-.092.32.32 0 0 1-.092-.271c.294-2.502 1.174-5.747 2.016-6.59a3.5 3.5 0 0 1 2.478-1.024c.898 0 1.794.342 2.478 1.024a3.51 3.51 0 0 1 0 4.955zm1.414-6.369a5.5 5.5 0 0 0-1.363-.997L19.15 2.489c.65-.65 1.711-.65 2.361 0s.65 1.709 0 2.36L11.384 14.975a5.5 5.5 0 0 0-.997-1.363M4.722 9.91a.997.997 0 0 0 1.414 0 1 1 0 0 0 0-1.414L2.49 4.85a1.67 1.67 0 0 1 0-2.361 1.67 1.67 0 0 1 2.36 0l3.646 3.647A.999.999 0 1 0 9.91 4.722L6.264 1.075a3.675 3.675 0 0 0-5.19-.001 3.674 3.674 0 0 0 0 5.189zM22.242 17.054l-2.955-2.956a.999.999 0 1 0-1.414 1.414l2.955 2.956A4.02 4.02 0 0 1 22 21.296V22h-.703a3.97 3.97 0 0 1-2.829-1.172l-2.956-2.955a.999.999 0 1 0-1.414 1.414l2.956 2.955A5.96 5.96 0 0 0 21.297 24H23a1 1 0 0 0 1-1v-1.704c0-1.58-.641-3.127-1.758-4.242" />
    </g>
    <defs>
      <clipPath id="fi-rr-paintbrush-pencil_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPaintbrushPencil;
